import React, { useState, useImperativeHandle, forwardRef } from 'react'
import { Button } from '@material-ui/core'

//dispatcher
import { useDispatch, useSelector } from 'react-redux'

//actions
import { handleModal } from '../../../../__actions/globalModals'

//images
import closeIcon from '../../../../assets/images/modals/messages/first-video-watched/icons/close.png'
import checkIcon from '../../../../assets/images/modals/messages/first-video-watched/icons/check.png'

function WatchedFirstVideoOfFirstTopicActivated(props, ref) {
    const dispatch = useDispatch()

    //
    const __data = useSelector(state => state)
    //
    const data = __data?.globalModalsReducer?.WATCHED_FIRST_VIDEO?.data || {}

    const [state, setState] = useState({
        blur: false,
        popup: false,
    })

    useImperativeHandle(ref, () => ({
        open: () => handleOpen(),
        close: () => handleClose()
    }))

    const handleOpen = () => {
        document.querySelector('body').style.overflow = 'hidden'
        document.querySelector('html').style.overflow = 'hidden'

        setState(state => ({
            ...state,
            blur: true,
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                popup: true
            }))
        }, 50)
    }

    const handleClose = () => {
        dispatch(handleModal('WATCHED_FIRST_VIDEO', false, {}))

        document.querySelector('body').style.overflow = 'initial'
        document.querySelector('html').style.overflow = 'initial'
        setState(state => ({
            ...state,
            popup: false
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                blur: false,
            }))
        }, 100)
    }

    return (
        <div id="overlay" className={`scrollable-mobile ${state.blur ? 'visible' : ''}`}>
            <div className={`box watched-first-video ${state.popup ? 'show' : ''}`}>
                {/* <img
                    src={closeIcon}
                    className="close"
                    alt="Затваряне"
                    title="Затваряне"
                    onClick={handleClose}
                /> */}
                <img src={window.innerWidth <= 1024 ? data?.filename_big : data?.filename} className="main" />
                <h4>
                    {data?.name}, видя колко лесно и удобно придобиваш знания по теория за твоето
                    перфектно шофиране.
                </h4>
                <div className="exam">
                    <div className="left">
                        <img src={checkIcon} />
                        <div className="right-part">
                            <h5>
                                100%
                            </h5>
                            <h6>
                                взет изпит
                            </h6>
                        </div>
                    </div>
                    <p className="right">
                        С гордост ти казвам, че <b>100%</b> от кандидат-шофьорите
                        преминали през Авто Обучение вземат изпита по теория <b>от първия път.</b>
                    </p>
                </div>
                <ul className="includes">
                    <li>
                        <img src={checkIcon} />
                        <p>
                            С помощта на Авто Обучение придобиваш трайни знания, които те правят <b>по-подготвен и уверен шофьор</b> на пътя. По този начин заедно с теб подобряваме движението по пътищата в България.
                        </p>
                    </li>
                    <li>
                        <img src={checkIcon} />
                        <p>
                            {data?.name}, ние вярваме в теб и знаем, че ще бъдеш <b>шофьор за пример</b> на останалите водачи на пътя!
                        </p>
                    </li>
                </ul>
                <p>
                    Премини през всичи 19 теми, за да се подготвиш отлично за теоретични изпит
                </p>
                <br />
                <br />
                <p>
                    <b>
                        С най-добри пожелания,
                        <br />
                        Йоанна Костова!
                   </b>
                </p>
                <br />
                <Button className="primary primary-activated" onClick={() => handleClose()}>
                    Разбрах
                </Button>
            </div>
        </div >
    )
}

export default forwardRef(WatchedFirstVideoOfFirstTopicActivated)